import { useCallback, useEffect, useRef } from "react";
import useScroll from "./scroll-hook";


const useScrollComponent = <T>(isScrollToViewAtMount?: boolean) => {
    const { scrollIntoView } = useScroll();
    const elemRef = useRef<T>(null);


    useEffect(() => {
        if (isScrollToViewAtMount && elemRef.current) {
            scrollIntoView(elemRef.current as any);   
        }
    }, [isScrollToViewAtMount, scrollIntoView]);

    const _scrollIntoView = useCallback(() => {
        if (elemRef.current) {
            scrollIntoView(elemRef.current as any);   
        }
    }, [scrollIntoView]);

    return {
        elemRef, 
        scrollIntoView: _scrollIntoView
    }
}

export default useScrollComponent;